// Test IDs for the public RELATABLE site & admin.
export const SITE = {
  preloaderRoot: 'preloader-root',
  preloaderSkip: 'preloader-skip',
  navRoot: 'nav-root',
  navWork: 'nav-work',
  navAbout: 'nav-about',
  navContact: 'nav-contact',
  navStartProject: 'nav-start-project-btn',
  heroRoot: 'hero-root',
  heroViewWork: 'hero-view-work-btn',
  heroStartProject: 'hero-start-project-btn',
  trustedBySection: 'trusted-by-section',
  selectedWork: 'selected-work-section',
  workCard: 'work-card',
  whatWeSolve: 'what-we-solve-section',
  whoWeWorkWith: 'who-we-work-with-section',
  servicesSection: 'services-section',
  proofSection: 'proof-section',
  legacySection: 'legacy-section',
  insightsSection: 'insights-section',
  contactSection: 'contact-section',
  footer: 'footer-root',
  workPage: 'work-page',
  aboutPage: 'about-page',
  contactPage: 'contact-page',
  contactForm: 'contact-form',
  contactName: 'contact-name-input',
  contactEmail: 'contact-email-input',
  contactCompany: 'contact-company-input',
  contactType: 'contact-type-select',
  contactBudget: 'contact-budget-select',
  contactMessage: 'contact-message-input',
  contactSubmit: 'contact-submit-btn',
  caseStudyPage: 'case-study-page',
};

export const ADMIN = {
  loginPage: 'admin-login-page',
  loginPasswordInput: 'admin-login-password-input',
  loginSubmit: 'admin-login-submit',
  dashboard: 'admin-dashboard',
  tabProjects: 'admin-tab-projects',
  tabCaseStudies: 'admin-tab-case-studies',
  tabLeads: 'admin-tab-leads',
  logoutBtn: 'admin-logout-btn',
  newProjectBtn: 'admin-new-project-btn',
  projectRow: 'admin-project-row',
  newCaseStudyBtn: 'admin-new-case-study-btn',
  caseStudyRow: 'admin-case-study-row',
  leadRow: 'admin-lead-row',
};
